export default "__VITE_ASSET__BtOgGZgp__"